/*
 * @Author: Leeon 282276848@qq.com
 * @Date: 2024-03-28 16:39:34
 * @LastEditors: Leeon 282276848@qq.com
 * @LastEditTime: 2024-03-28 17:43:29
 * @FilePath: \jirh-h5\src\mixinx\applyBus.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as API_Common from "@/api/common.js";
import { setEncryption } from "@/utils/encrypt"; //引入加密文件
import Storage from "@/utils/storage";
const DUPLICATE_SUBMIT_CODES = [1109, 1110, 1004, 1005, 1006]; // 重复提交相关错误码
const MATCH_NAV_DELAY = 800; // 遮罩结束后再处理结果的短暂延迟（ms）

export const applyBus = {
  data() {
    return {
      matchVisible: false, // 额度评估遮罩是否展示
      matchRunning: false, // 匹配流程是否进行中（动画 + 进件）
      matchAnimationDone: false, // 遮罩三步动画是否播完
      matchSubmitDone: false, // 进件接口是否已返回
      // 进件结果：matchSuccess=跳转匹配成功页；stay=toast后留在当前页；fail=失败并跳转
      matchSubmitOutcome: "fail",
      matchErrorLogData: null, // 接口异常时暂存埋点参数，收尾时上报
      matchOrderSn: "", // 匹配成功页入参 orderSn
    };
  },
  methods: {
    /**
     * 开启额度评估遮罩，重置匹配态，并打开按钮 loading
     */
    beginMatchSubmit() {
      this.matchVisible = true;
      this.matchRunning = true;
      this.matchAnimationDone = false;
      this.matchSubmitDone = false;
      this.matchSubmitOutcome = "fail";
      this.matchErrorLogData = null;
      this.matchOrderSn = "";
      // 按钮loading
      this.loading = true;
    },

    /**
     * MatchLoading 动画播放完毕回调
     */
    onMatchAnimFinish() {
      this.matchAnimationDone = true;
      this.tryFinishMatchSubmit();
    },

    /**
     * 立即关闭额度评估遮罩（重复提交等需马上回到表单的场景）
     */
    closeMatchLoadingImmediately() {
      this.matchRunning = false;
      this.matchVisible = false;
      this.matchAnimationDone = true;
      this.matchSubmitDone = true;
      // 取消按钮loading
      this.loading = false;
      if (typeof this.submitting !== "undefined") {
        this.submitting = false;
      }
    },

    /**
     * 动画与进件均完成后收尾：
     * - matchSuccess：跳转匹配成功页（协议展示 + 领取额度）
     * - stay：重复提交等场景，toast 后留在当前页（通常已提前 closeMatchLoadingImmediately）
     * - fail：失败跳转（必要时补记异常埋点）
     */
    tryFinishMatchSubmit() {
      if (
        !this.matchAnimationDone ||
        !this.matchSubmitDone ||
        !this.matchRunning
      ) {
        return;
      }

      this.matchRunning = false;
      // 取消按钮loading
      this.loading = false;
      if (typeof this.submitting !== "undefined") {
        this.submitting = false;
      }

      setTimeout(() => {
        this.matchVisible = false;

        if (this.matchSubmitOutcome === "matchSuccess") {
          // 携带 orderSn、applyId 等进入匹配成功页；展示数据由该页自行请求 matchResultV2
          this.$router.push({
            name: "MatchSuccess",
            query: {
              orderSn: this.matchOrderSn,
              applyId: this.applyId,
              source: this.form.channelNo,
              amount: this.form.loanAmount,
              brand: this.brand,
              downPageUrl: this.downPageUrl,
              reqId: this.form.reqId,
              isRedirectProductsPage: this.isRedirectProductsPage,
              isRedirectWorkWeixinPage: this.isRedirectWorkWeixinPage,
            },
          });
          return;
        }

        if (this.matchSubmitOutcome === "stay") {
          return;
        }

        if (this.matchErrorLogData) {
          const logData = this.matchErrorLogData;
          this.matchErrorLogData = null;
          delete logData.applyId;
          logData.errorType = 2;
          // 添加埋点
          API_Common.addMatchStayLog(logData);
        }

        // 需要跳转的页面
        this.gotoNextPage(false);
      }, MATCH_NAV_DELAY);
    },

    /**
     * 调用共同进件接口 submitAnEntry（/rsa/loan/h5ApplyV2），与额度评估遮罩并行
     * 接口结果写入 matchSubmitOutcome，由 tryFinishMatchSubmit 统一收尾
     */
    async submitAnEntryWithMatchLoading(datas) {
      this.beginMatchSubmit();

      // 日志参数
      const logData = {
        applyId: null,
        channel: this.form.channelNo,
        pageUrl: window.location.href,
        errorType: null,
        applySource: 2,
        errorMsg: null,
      };

      try {
        const res = await API_Common.submitAnEntry(datas);
        // 埋点数据的值
        logData.errorType = 1;
        logData.applyId = res?.data?.applyId;
        logData.errorMsg = res?.msg;

        if (res?.code === 200) {
          // applyId 为 0 表示未匹配到机构；非 0 表示匹配成功
          // 进件ID
          this.applyId = res.data.applyId;
          // 产品ID（匹配成功页 / pushApply 使用）
          this.productId = res.data.productId;
          // 是否推送成功：1 成功，0 失败（用于判断是否进入匹配成功页）
          this.sendData = res.data;
          this.hasPushSuccess = res.data.hasPushSuccess;
          this.applyTime = res.data.applyTime;
          // 三方重定向地址（同意协议后若有值则直接跳转，不再调 pushApply）
          this.redirectUrl = res.data.redirectUrl;
          // 匹配成功页请求 matchResultV2 的入参
          this.matchOrderSn = res.data.orderSn || "";

          // 匹配成功：关遮罩后跳转 MatchSuccess（展示协议，点「同意协议，领取额度」走 handleGoOn）
          // 对齐小程序：applyId != 0 且 hasPushSuccess === 1 且有 orderSn
          // 否则：关遮罩后走失败跳转 gotoNextPage(false)
          const matched =
            this.applyId !== 0 && Number(this.hasPushSuccess) === 1;
          if (matched && this.matchOrderSn) {
            this.matchSubmitOutcome = "matchSuccess";
          } else {
            this.matchSubmitOutcome = "fail";
          }
        } else if (DUPLICATE_SUBMIT_CODES.includes(res?.code)) {
          // 添加埋点
          API_Common.addMatchStayLog(logData);
          // 区分贷超流程以及非贷超流程
          // 1109:进件的时候手机号是同一个身份证是同一个重复提交-跳转红包下载页面
          // 1110: 此处判断为进件重复(规则是进件的时候身份证是一个但是手机号不同的情况-跳转红包下载页面)
          // 1004/1005/1006: 同类重复/校验类错误，立即关遮罩，toast 后留在当前页
          this.$toast(res.msg);
          this.matchSubmitOutcome = "stay";
          this.closeMatchLoadingImmediately();
        } else {
          // 添加埋点
          API_Common.addMatchStayLog(logData);
          // 需要跳转的页面
          this.$toast(res.msg);
          this.matchSubmitOutcome = "fail";
        }
      } catch (error) {
        this.$toast({
          message: "当前申请人数较多，请重新提交获取结果",
          duration: 3000,
        });
        // 异常埋点放到收尾时上报，避免遮罩未结束就跳转
        this.matchErrorLogData = {
          ...logData,
          errorMsg: String(error),
        };
        this.matchSubmitOutcome = "fail";
      } finally {
        this.matchSubmitDone = true;
        this.tryFinishMatchSubmit();
      }
    },

    // step1 表单提交（registerEntry_tl9）
    async handleSubmit() {
      if (this.form.realName === "") {
        this.$toast("请输入姓名");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      } else if (this.form.idCard === "") {
        this.$toast("请输入身份证号码");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      } else if (!this.regTest.regIdcard.test(this.form.idCard)) {
        this.$toast("请输入正确的身份证号码");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      } else if (this.form.credit === "") {
        this.$toast("请选择芝麻分");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }

      this.formItemData.creditType.map((i) => {
        if (i.active) {
          this.form.assets.push(i.dictValue);
        }
      });

      if (this.form.assets.length === 0) {
        this.$toast("请至少选择一项资产");
        return;
      }

      if (!this.positionStatus && this.form.cityId === "") {
        this.$toast("请选择您所在的城市");
        return;
      } else if (!this.checked) {
        this.$toast("请勾选同意授权及告知书");
        return;
      }

      // 组装进件参数（姓名/身份证加密），随后走遮罩 + 共同进件接口
      let datas = {
        ...this.form,
        ...{
          realName: setEncryption(this.form.realName),
          idCard: setEncryption(this.form.idCard),
        },
      };

      this.submitAnEntryWithMatchLoading(datas);
    },

    // step1 表单提交（registerEntry_tl10 / tl11）
    async handleSubmitTl2() {
      if (this.form.realName === "") {
        this.$toast("请输入姓名");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }
      if (this.form.idCard === "") {
        this.$toast("请输入身份证号码");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }

      if (!this.regTest.regIdcard.test(this.form.idCard)) {
        this.$toast("请输入正确的身份证号码");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }

      if (this.form.credit === "") {
        this.$toast("请选择芝麻分");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }

      this.formItemData.creditType.map((i) => {
        if (i.active) {
          this.form.assets.push(i.dictValue);
        }
      });

      if (this.form.assets.length === 0) {
        this.$toast("请至少选择一项资产");
        return;
      }

      if (!this.positionStatus && this.form.cityId === "") {
        this.$toast("请选择您所在的城市");
        return;
      }

      if (!this.checked) {
        this.$toast("请勾选同意授权及告知书");
        return;
      }

      // 组装进件参数（姓名/身份证加密），随后走遮罩 + 共同进件接口
      let datas = {
        ...this.form,
        ...{
          realName: setEncryption(this.form.realName),
          idCard: setEncryption(this.form.idCard),
        },
      };

      this.submitAnEntryWithMatchLoading(datas);
    },

    // step1 表单提交
    async handleSubmitTl3() {
      if (this.form.realName === "") {
        this.$toast("请输入姓名");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      } else if (this.form.idCard === "") {
        this.$toast("请输入身份证号码");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      } else if (!this.regTest.regIdcard.test(this.form.idCard)) {
        this.$toast("请输入正确的身份证号码");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      } else if (this.form.credit === "") {
        this.$toast("请选择芝麻分");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      } else if (this.assetFromJS.house === "") {
        this.$toast("请选择房产信息");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      } else if (this.assetFromJS.car === "") {
        this.$toast("请选择车产信息");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      } else if (this.assetFromJS.accumulation === "") {
        this.$toast("请选择公积金");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      } else if (this.assetFromJS.social === "") {
        this.$toast("请选择社保");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      } else if (this.assetFromJS.insurance === "") {
        this.$toast("请选择商业保险");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      } else if (this.assetFromJS.profession === "") {
        this.$toast("请选择职业信息");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }

      if (this.form.antCreditPay === "") {
        this.$toast("请选择蚂蚁花呗");
        return;
      } else if (this.form.jdIous === "") {
        this.$toast("请选择京东白条");
        return;
      } else if (!this.positionStatus && this.form.cityId === "") {
        this.$toast("请选择您所在的城市");
        return;
      }

      this.setAssetArray();
      if (this.form.assets.length === 0) {
        this.$toast("请至少选择一项资产");
        return;
      }

      // // 按钮loading
      this.loading = false;
      let datas = {
        ...this.form,
        ...{
          realName: setEncryption(this.form.realName),
          idCard: setEncryption(this.form.idCard),
        },
      };
      // 日志参数
      let logData = {
        applyId: null,
        channel: this.form.channelNo,
        pageUrl: window.location.href,
        errorType: null,
        applySource: 2,
        errorMsg: null,
      };
      try {
        let res = await API_Common.saveApplyData(datas);
        //埋点数据的值
        logData.errorType = 1;
        logData.errorMsg = res?.msg;
        if (res?.code === 200) {
          // 跳转到匹配中页面
          this.$router.push({
            name: "MatchWaiting",
            query: {
              source: this.form.channelNo,
              orderSn: res.data.orderSn,
              brand: this.brand,
              amount: this.form.loanAmount,
              downPageUrl: this.downPageUrl,
              isRedirectProductsPage: this.isRedirectProductsPage,
              isRedirectWorkWeixinPage: this.isRedirectWorkWeixinPage,
            },
          });
        } else if (
          res?.code === 1110 ||
          res?.code === 1004 ||
          res?.code === 1005 ||
          res?.code === 1006
        ) {
          // 取消按钮loading
          this.loading = false;
          //添加埋点
          API_Common.addMatchStayLog(logData);
          this.$toast(res.msg);
        } else {
          this.loading = false;
          // 添加埋点
          API_Common.addMatchStayLog(logData);
          //需要跳转的页面
          this.gotoNextPage(false);
          this.$toast(res.msg);
        }
      } catch (error) {
        this.requestErrorHandle(error, logData);
      }
    },

    // step1 表单提交
    async handleSubmitTl7() {
      if (this.form.realName === "") {
        this.$toast("请输入姓名");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }
      if (this.form.idCard === "") {
        this.$toast("请输入身份证号码");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }
      if (!this.regTest.regIdcard.test(this.form.idCard)) {
        this.$toast("请输入正确的身份证号码");
        this.$refs.container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }
      if (this.form.credit === "") {
        this.$toast("请选择芝麻分");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }
      if (this.assetFromJS.house === "") {
        this.$toast("请选择房产信息");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }
      if (this.assetFromJS.car === "") {
        this.$toast("请选择车产信息");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }

      if (this.assetFromJS.social === "") {
        this.$toast("请选择社保");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }

      if (this.assetFromJS.accumulation === "") {
        this.$toast("请选择公积金");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }

      if (this.assetFromJS.insurance === "") {
        this.$toast("请选择商业保险");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }
      if (this.assetFromJS.profession === "") {
        this.$toast("请选择职业信息");
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: "smooth",
        });
        return;
      }

      this.setAssetArray();
      if (this.form.assets.length === 0) {
        this.$toast("请至少选择一项资产");
        return;
      }

      // 按钮loading
      this.loading = true;

      let datas = {
        ...this.form,
        ...{
          realName: setEncryption(this.form.realName),
          idCard: setEncryption(this.form.idCard),
        },
      };

      // 日志参数
      let logData = {
        applyId: null,
        channel: this.form.channelNo,
        pageUrl: window.location.href,
        errorType: null,
        applySource: 2,
        errorMsg: null,
      };
      try {
        let res = await API_Common.submitAnEntry(datas);
        //埋点数据的值
        logData.errorType = 1;
        logData.applyId = res?.data?.applyId;
        logData.errorMsg = res?.msg;
        if (res?.code === 200) {
          // 取消按钮loading
          this.loading = false;

          // 进件申请ID赋值(applyId如果为0则代表进件失败，否则代表成功
          // 1: 贷超流程，失败了要跳转贷超页面
          // 2: 贷超流程，成功了要跳转进件完成页面(并且结果页面按钮展示为<我知道了>),点击我知道了跳转贷超页面
          //进件ID
          this.applyId = res.data.applyId;
          // 产品ID
          this.productId = res.data.productId;
          // 是否推送成功;
          // 1: 贷超流程，失败了要跳转贷超页面
          // 2: 贷超流程，成功了要跳转进件完成页面(并且结果页面按钮展示为<我知道了>),点击我知道了跳转贷超页面
          this.sendData = res.data; //发送给协议弹窗页面
          this.hasPushSuccess = res.data.hasPushSuccess;
          this.applyTime = res.data.applyTime;
          // 重定向页面地址
          this.redirectUrl = res.data.redirectUrl;

          this.incomingShow = true;
          if (this.applyId !== 0 && this.hasPushSuccess) {
            this.companys = res.data.apiNames.join("、");
            this.companyAlias = res.data.apiAlias;
          } else {
            this.companys = "";
          }
        } else if (
          res?.code === 1109 ||
          res?.code === 1110 ||
          res?.code === 1004 ||
          res?.code === 1005 ||
          res?.code === 1006
        ) {
          // 取消按钮loading
          this.loading = false;
          //添加埋点
          API_Common.addMatchStayLog(logData);
          // 区分贷超流程以及非贷超流程
          // 1109:进件的时候手机号是同一个身份证是同一个重复提交-跳转红包下载页面
          // 1110: 此处判断为进件重复(规则是进件的时候身份证是一个但是手机号不同的情况-跳转红包下载页面)
          this.$toast(res.msg);
        } else {
          this.loading = false;
          // 添加埋点
          API_Common.addMatchStayLog(logData);
          //需要跳转的页面
          this.gotoNextPage(false);
          this.$toast(res.msg);
        }
      } catch (error) {
        this.requestErrorHandle(error, logData);
      }
    },

    // step2 同意协议后推送进件（匹配成功页「同意协议，领取额度」/ 原 Agreement「我已知晓」共用）
    async submitPushApply() {
      // 有重定向 直接跳转
      if (this.redirectUrl) {
        // 跳转到三方页面
        window.open(this.redirectUrl);
        return;
      }

      // 匹配失败
      if (this.hasPushSuccess === 0) {
        this.gotoNextPage(false);
        return;
      }

      this.loading = true;

      // 调用推送进件接口
      try {
        var res = await API_Common.pushApply({
          applyId: this.applyId,
          productId: this.productId,
        });
        this.loading = false;
        if (res.code === 200) {
          const hasPushSucces = res.data.hasPushSuccess;
          this.gotoNextPage(hasPushSucces);
        } else {
          this.gotoNextPage(false);
        }
      } catch (err) {
        this.loading = false;
        this.gotoNextPage(false);
      }
    },
    //跳转下一个页面
    gotoNextPage(hasPushSuccess) {
      if (hasPushSuccess) {
        var timestamp = new Date().getTime();
        // 跳转到成功结果页, 不管什么贷超流程
        window.location.href =
          `${this.downPageUrl}?source=${this.form.channelNo}&brand=${this.brand}&amount=${this.form.loanAmount}&applyId=${this.applyId}&isRedirectProductsPage=${this.isRedirectProductsPage}` +
          "&tsp=" + timestamp +
          "&reqId=" + this.form.reqId;
        return;
      }

      if (this.isRedirectProductsPage === 1) {
          // 跳转到贷超，通过Hash传递jwt（Cookie降级方案）
          setTimeout(() => {
              var timestamp = new Date().getTime();
              const jwt = this.$store.state.jwt || '';
              const baseUrl =
                  `/func/productList.html?source=${this.form.channelNo}` +
                  "&brand=" + this.brand +
                  "&tsp=" + timestamp +
                  "&reqId=" + this.form.reqId;
              window.location.href = Storage.buildUrlWithToken(baseUrl, jwt);
          }, 1500);
      } else {
        // 非贷超：跳转兜底下载页（引导去 APP 激活额度）
        setTimeout(() => {
          this.$router.push({
            name: "ApplyResult",
            query: {
              source: this.form.channelNo,
              brand: this.brand,
              loanAmount: this.form.loanAmount,
            },
          });
        }, 1500);
      }
    },
    // 同意协议下一步（匹配成功页按钮 / Agreement 弹窗共用，内部走 submitPushApply）
    handleGoOn() {
      if (this.loading) {
        return;
      }
      this.submitPushApply();
    },

    // 匹配报错处理
    requestErrorHandle(error, logData) {
      // 添加埋点
      delete logData.applyId;
      logData.errorType = 2;
      logData.errorMsg = error.toString();
      this.$toast({
        message: "当前申请人数较多，请重新提交获取结果",
        duration: 3000,
      });
      setTimeout(() => {
        this.loading = false;
        API_Common.addMatchStayLog(logData);
        this.gotoNextPage(false);
      }, 3000);
    },

    // 处理页面加载完成
    handleLoadFinish(pid) {
      let logData = {
        pageId: 2,
        templateId: pid,
        reqId: this.form.reqId,
        channel: this.form.channelNo,
        pageUrl: window.location.href
      };
      API_Common.applyStayMonitor(logData);
    },
  },
};
